<template>
  <div class="trends-reports">
    <div class="file-selection-bar-single margin-bottom">
      <form class="noFlex" v-on:change="sortByTrgroups(selected)">
        <label for="report-date" class="visually-hidden">Select a Report</label>
        <select name="report-date" id="report-date" v-model="selected">
          <option value="" selected>All Articles</option>
          <template v-for="trgroup in trgroupsonload" :key="trgroup">
            <option v-bind:value="trgroup.id">{{ trgroup.name }}</option>
          </template>
        </select>
      </form>
    </div>

    <div class="trends-report-group" v-for="trgroup in trgroups" :key="trgroup">
      <h3>{{ trgroup.name }}</h3>
      <div class="three-col-wrapper">
        <template v-for="reporttype in trgroup.tr_report_types_index">
          <template v-if="reporttype.first_report == null">
            {{ hasXMLcontent(false) }}
            {{ noFirstReport(reporttype.id) }}
          </template>
          <template
            v-else-if="reporttype.first_report.xml_content_json == null"
          >
            {{ hasXMLcontent(false) }}
          </template>

          <div class="col-inner" v-else :key="reporttype">
            {{ hasXMLcontent(true) }}
            <div class="article-card">
              <a
                class="article-main-link"
                :href="'/trendsreport/' + reporttype.url"
              >
                <div class="article-card--top">
                  <h5>{{ reporttype.name }}</h5>
                  <template v-if="reporttype.first_report">
                    <p class="date-text">
                      {{
                        momentFormat(reporttype.first_report.issue, 'MMMM YYYY')
                      }}
                    </p>
                    <p class="small" v-if="reporttype.first_report.summary">
                      {{ summaryText(reporttype.first_report.summary) }}
                    </p>
                    <p class="small" v-else>
                      {{ summaryText(reporttype.summary) }}
                    </p>
                  </template>
                  <template v-else>
                    {{ noFirstReport(reporttype.id) }}
                  </template>
                </div>

                <div class="article-card--image" v-if="reporttype.image">
                  <img
                    :src="'/storage/' + reporttype.image"
                    :alt="reporttype.name"
                  />
                </div>
              </a>

              <div class="article-card--buttons">
                <!-- Email Alert -->
                <template v-if="reporttype.is_email_alert">
                  <template v-if="ismobiledevice">
                    <a
                      v-on:click="removeFromAlertList(reporttype)"
                      class="active vue-anchor"
                      data-placement="top"
                      title="Set Notification for Article"
                    >
                      <span class="icon-notification">
                        <span class="visually-hidden">
                          Set Notification for this Article
                        </span>
                      </span>
                    </a>
                  </template>
                  <template v-else>
                    <a
                      v-on:click="removeFromAlertList(reporttype)"
                      class="active vue-anchor"
                      data-placement="top"
                      title="Set Notification for Article"
                    >
                      <span class="icon-notification">
                        <span class="visually-hidden">
                          Set Notification for this Article
                        </span>
                      </span>
                    </a>
                  </template>
                </template>
                <template v-else>
                  <template v-if="ismobiledevice">
                    <a
                      v-on:click="addToAlertList(reporttype)"
                      class="vue-anchor"
                      data-placement="top"
                      title="Set Notification for Article"
                    >
                      <span class="icon-notification">
                        <span class="visually-hidden">notify me</span>
                      </span>
                    </a>
                  </template>
                  <template v-else>
                    <a
                      v-on:click="addToAlertList(reporttype)"
                      class="vue-anchor"
                      data-placement="top"
                      title="Set Notification for Article"
                    >
                      <span class="icon-notification">
                        <span class="visually-hidden">notify me</span>
                      </span>
                    </a>
                  </template>
                </template>
                <!-- View Report -->
                <template v-if="ismobiledevice">
                  <a
                    :href="'/trendsreport/' + reporttype.url"
                    class="vue-anchor"
                    data-placement="top"
                    title="View Article"
                  >
                    <span class="icon-view">
                      <span class="visually-hidden">View this Article</span>
                    </span>
                  </a>
                </template>
                <template v-else>
                  <a
                    :href="'/trendsreport/' + reporttype.url"
                    class="vue-anchor"
                    data-placement="top"
                    title="View Article"
                  >
                    <span class="icon-view">
                      <span class="visually-hidden">View this Article</span>
                    </span>
                  </a>
                </template>

                <!-- Modal -->
                <template v-if="ismobiledevice">
                  <a
                    @click="previewModal(reporttype)"
                    class="vue-anchor"
                    data-toggle="modal"
                    data-target="#tr_modal"
                    data-placement="top"
                    title="Preview Article"
                  >
                    <span class="icon-preview-arrow">
                      <span class="visually-hidden">Preview this Article</span>
                    </span>
                  </a>
                </template>
                <template v-else>
                  <a
                    @click="previewModal(reporttype)"
                    class="vue-anchor"
                    data-toggle="modal"
                    data-target="#tr_modal"
                    data-placement="top"
                    title="Preview Article"
                  >
                    <span class="icon-preview-arrow">
                      <span class="visually-hidden">Preview this Article</span>
                    </span>
                  </a>
                </template>

                <!-- Favorite -->
                <template v-if="reporttype.is_favorite">
                  <template v-if="ismobiledevice">
                    <a
                      v-on:click="removeFromFavroties(reporttype)"
                      class="active vue-anchor"
                      data-placement="top"
                      title="Favorite Article"
                    >
                      <span class="icon-star">
                        <span class="visually-hidden">Favorite</span>
                      </span>
                    </a>
                  </template>
                  <template v-else>
                    <a
                      v-on:click="removeFromFavroties(reporttype)"
                      class="active vue-anchor"
                      data-placement="top"
                      title="Favorite Article"
                    >
                      <span class="icon-star">
                        <span class="visually-hidden">Favorite</span>
                      </span>
                    </a>
                  </template>
                </template>
                <template v-else>
                  <template v-if="ismobiledevice">
                    <a
                      v-on:click="addToFavorites(reporttype)"
                      class="vue-anchor"
                      data-placement="top"
                      title="Favorite Article"
                    >
                      <span class="icon-star">
                        <span class="visually-hidden">
                          Favorite this Article
                        </span>
                      </span>
                    </a>
                  </template>
                  <template v-else>
                    <a
                      v-on:click="addToFavorites(reporttype)"
                      class="vue-anchor"
                      data-placement="top"
                      title="Favorite Article"
                    >
                      <span class="icon-star">
                        <span class="visually-hidden">
                          Favorite this Article
                        </span>
                      </span>
                    </a>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- three col wrapper-->
    </div>
    <!--trends report group-->

    <!-- <template v-if="modalup" > -->
    <component
      :key="imagespath"
      v-bind:is="modalcomponent"
      v-bind:content="json_content"
      v-bind:imagespath="imagespath"
      v-bind:reporturl="reporturl"
      v-bind:reporttitle="reporttitle"
      @modal-closed="handleModalClosed"
    />
    <!--</template> -->
  </div>
</template>

<script>
  import moment from 'moment';
  //MODAL components  //have to add next tick to each component mounted to show modal.
  import ModalIndicatorTypeA from './templates/preview/ModalIndicatorTypeA.vue';
  import ModalIndicatorTypeB from './templates/preview/ModalIndicatorTypeB.vue';
  import ModalAtAGlance from './templates/preview/ModalAtAGlance.vue';
  import ModalTrends10 from './templates/preview/ModalTrends10.vue';
  import ModalLeadingIndicator from './templates/preview/ModalLeadingIndicator.vue';
  import ModalEconomicOutlook from './templates/preview/ModalEconomicOutlook.vue';
  import ModalIndicatorTypes from './templates/preview/ModalIndicatorTypes.vue';
  import ModalExecutiveSummary from './templates/preview/ModalExecutiveSummary.vue';

  export default {
    props: {
      app_url: {
        type: String,
        required: true,
      },
    },
    mounted() {
      //get all tr groups
      this.getTrgroups();
    },
    components: {
      'tr-indicator-type-a-modal-component': ModalIndicatorTypeA,
      'tr-indicator-type-b-modal-component': ModalIndicatorTypeB,
      'tr-at-a-glance-modal-component': ModalAtAGlance,
      'tr-trends-10-modal-component': ModalTrends10,
      'tr-leading-indicator-modal-component': ModalLeadingIndicator,
      'tr-economic-outlook-modal-component': ModalEconomicOutlook,
      'tr-indicator-types-modal-component': ModalIndicatorTypes,
      'tr-executive-summary-modal-component': ModalExecutiveSummary,
    },
    data: function () {
      return {
        trgroups: [],
        selected: '', //for sort by select up top
        trgroupsonload: [],
        ismobiledevice: false,
        bs_modal: {},
        json_content: {},
        modalcomponent: '',
        imagespath: '',
        reporturl: '',
        reporttitle: '',
        XMLcontent: false,
        //modalup: false
      };
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
      handleModalClosed() {
        this.modalcomponent = '';
        this.json_content = '';
        this.imagespath = '';
        this.reporturl = '';
        this.reporttitle = '';
      },
      previewModal(reporttype) {
        this.bs_modal = reporttype.first_report;
        this.imagespath = this.app_url + '/storage/' + reporttype.first_report.images_path + '/';
        this.reporturl = '/trendsreport/' + reporttype.url;
        this.reporttitle = reporttype.name;
        this.json_content = JSON.parse(
          reporttype.first_report.xml_content_json
        );
        // this.modalcomponent = 'tr-modal-'+ reporttype.template_name +'-component';
        this.modalcomponent = reporttype.template_name + '-modal-component';
      },
      getTrgroups: function () {
        //get all groups and object from api endpoing using passport validation
        var _this = this;
        axios
          .get('/api/v1/trendsreport/trgroups')
          .then((success) => {
            _this.trgroups = success.data.data;
            _this.trgroupsonload = success.data.data;
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      sortByTrgroups: function (value) {
        var _this = this;
        axios
          .get('/api/v1/trendsreport/trgroups/' + value)
          .then((success) => {
            _this.trgroups = success.data.data;
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      addToFavorites: function (reporttype) {
        axios
          .post('/trendsreport/' + reporttype.id + '/addToFavorites', {
            /*paramas here*/
          })
          .then((success) => {
            reporttype.is_favorite = true;
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      removeFromFavroties: function (reporttype) {
        axios
          .post('/trendsreport/' + reporttype.id + '/removeFavorites', {
            /*paramas here*/
          })
          .then((success) => {
            reporttype.is_favorite = false;
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      addToAlertList: function (reporttype) {
        axios
          .post('/trendsreport/' + reporttype.id + '/addToAlertList', {
            /*paramas here*/
          })
          .then((success) => {
            reporttype.is_email_alert = true;
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      removeFromAlertList: function (reporttype) {
        axios
          .post('/trendsreport/' + reporttype.id + '/removeFromAlertList', {
            /*paramas here*/
          })
          .then((success) => {
            reporttype.is_email_alert = false;
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      //helpers
      hasXMLcontent: function (value) {
        this.XMLcontent = value;
      },
      summaryText: function (text) {
        if (text == null) {
          return null;
        }
        return text.substring(0, 91) + '...';
      },
      noFirstReport: function (reportid) {
        //should never really reach here but... just in case
        axios
          .post('/api/v1/dev/issue/nofirstreport/' + reportid, {
            page_name: 'Trends Report Index',
            catch_template: 'TrendsReportIndexComponent.vue',
            catch_errors: 'No First Report Found',
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
    },
    computed: {},
  };
</script>
